module.exports = __webpack_public_path__ + "static/media/app-icon-white.b974ac83.svg";